import {Component, Input} from '@angular/core';

@Component({
  templateUrl: './map-widget.html',
  selector: 'map-widget',
  styles: [`
    .sebm-google-map-container {
      height: 420px;
    }
  `]
})
export class MapWidgetComponent {
  @Input() locations = {};
  @Input() center = {lat: 0, lon: 0};

  objectKeys = Object.keys;
}



// WEBPACK FOOTER //
// ./src/app/main/components/widgets/map/map-widget.component.ts